import React, { useEffect, useState } from "react";
import card from "Assets/images/card.jpg";
import { Dialog, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { useOrderAttributeProvider } from "../context/order";
import TextArea from "Components/FormControl/TextArea/TextArea";

const GreetingCard = () => {
  const formik = useFormikContext();
  const { active } = useOrderAttributeProvider();
  const [show, setShow] = useState(false);
  const [iframe, setIframe] = useState("");

  const videoUrl = formik.values.recipients[active]?.video_url;

  useEffect(() => {
    if (videoUrl && videoUrl.includes("vimeo")) {
      fetch(`https://vimeo.com/api/oembed.json?url=${videoUrl}`)
        .then((d) => d.json())
        .then((r) => {
          setIframe(r.html);
        });
    }
  }, [active, videoUrl]);

  const greetingCardMessage = formik.values?.recipients[active]?.greetings_on_card || "";

  return (
    <div className="my-5">
      {videoUrl && (
        <a
          className="d-inline-block mb-3"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShow(true);
          }}
        >
          {"Show video message"}
        </a>
      )}
      <Dialog open={show} onClick={() => setShow(false)}>
        {videoUrl && !iframe && (
          <video
            controls
            src={videoUrl}
          ></video>
        )}
        {iframe && <div dangerouslySetInnerHTML={{ __html: iframe }}></div>}
      </Dialog>
      <div
        style={{
          containerType: "inline-size",
          // = the 1264x589 art at 400px tall.
          width: "min(858.39px, 100%)",
        }}
      >
        <div
          style={{
            position: "relative",
            // 1.865cqw = 16px at the base card width, so the text scales with the art.
            fontSize: "1.865cqw",
            // The app sets a fixed 24px line-height, so the message block would not scale without this.
            lineHeight: 1.5,
          }}
        >
          <img style={{ display: "block", width: "100%" }} src={card} alt="Card" />
          <div
            style={{
              position: "absolute",
              top: "25%",
              overflowWrap: "break-word",
              width: "48%",
              textAlign: "center",
              left: "51.5%",
              transform: "translateX(-50%)",
              padding: "0 0.625em",
            }}
          >
            {greetingCardMessage}
          </div>
          <span
            style={{
              fontWeight: "bold",
              position: "absolute",
              top: "70.5%",
              padding: "0 1em",
              textAlign: "center",
              whiteSpace: "pre-line",
              wordBreak: "break-all",
              width: "48%",
              lineHeight: 1,
              left: "51.5%",
              transform: "translateX(-50%)",
            }}
          >
            {formik.values?.recipients[active]?.card_signature}
          </span>
        </div>
        <p className="text-right my-1">
          <span>
            {250 - greetingCardMessage.length} / 250 Characters Left
          </span>
        </p>

        <TextArea
          label="Write your greeting message here..."
          inputStyle={{ textAlign: "left" }}
          id={`recipients[${active}].greetings_on_card`}
          value={formik.values?.recipients[active]?.greetings_on_card}
          maxLength={250}
          onChangeWithEvent={formik.handleChange}
        />

        <TextField
          value={formik.values?.recipients[active]?.card_signature}
          name={`recipients[${active}].card_signature`}
          onChange={formik.handleChange}
          inputProps={{ maxLength: 59 }}
          className="w-100"
          label="Card Signature"
          variant="standard"
        />
      </div>
    </div>
  );
};

export default GreetingCard;
